/*  
 *  Archivo destinado a manejar todas las funciones responsables de comunicación con 
 *  el servidor, referentes al usuario.
 */

import fetchData from "./utils/fetchData";
import { v4 as uuidv4 } from "uuid"

const url = process.env.REACT_APP_SERVER_URL + '/alarma';

export const register = async (user, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + '/register', body: user }, dispatch);
    const result = data.result;
    if (result) {
        dispatch({ type: 'UPDATE_USER', payload: result });
        dispatch({ type: 'CLOSE_LOGIN' });
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: 'Usuario creado con éxito!' } });
    }

    dispatch({ type: 'END_LOADING' })
}

export const login = async (user, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //SEND REQUEST WITH FETCH
    //fetchData está en "actions>utils". Se utiliza para las comunicaciones con el servidor
    const data = await fetchData({ url: url + '/login', body: user }, dispatch);
    const result = data?.result;
    if (result) {
        dispatch({ type: 'UPDATE_USER', payload: result });
        dispatch({ type: 'CLOSE_LOGIN' });
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: 'Usuario logueado con éxito!' } });
    }

    dispatch({ type: 'END_LOADING' })
}

export const updateConfigAlarma = async (currentUser, deviceId, comando, configAlarma, dispatch) => {
    //dispatch({ type: 'START_LOADING' });

    //console.log({ currentUser, comando, deviceId, configAlarma });

    //SEND REQUEST WITH POST
    let body = { deviceId, comando, configAlarma };
    try {
        const data = await fetchData({ url: url + `/grabarConfig`, method: 'POST', body, token: currentUser.token }, dispatch);
        //console.log("Respuesta de fetch: ", data);
        const result = data?.result;
        if (result) {
            dispatch({ type: 'UPDATE_CONFIG_RESP', payload: result });

            return result;

            //dispatch({ type: 'UPDATE_USER', payload: { ...currentUser, ...result } });
            //dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: data.message } });
            //dispatch({ type: 'UPDATE_PROFILE', payload: { open: false, file: null, photoURL: result.photoURL } });
        } else {
            //dispatch({ type: 'UPDATE_PROFILE', payload: { open: false, file: null, photoURL: '' } });
            //dispatch({type: 'UPDATE_USER', payload: null});
            //dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: "Algo salió mal. Por favor intenete nuevamente en unos minutos." } });
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: data.error } });
            return;
        }

    } catch (error) {
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: error.message } });
        //console.log(error);
        return;
    }

    //dispatch({ type: 'END_LOADING' })
}

export const getConfigAlarma = async (currentUser, deviceId, comando, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //console.log({ currentUser, comando, deviceId });

    //SEND REQUEST WITH POST
    let body = { deviceId, comando };
    try {
        const data = await fetchData({ url: url + `/getConfig`, method: 'POST', body, token: currentUser.token }, dispatch);
        const result = data?.result;
        if (result) {
            //console.log({ result });
            dispatch({ type: 'END_LOADING' });
            return result;
        } else {
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: "Algo salió mal. Por favor intenete nuevamente en unos minutos." } });
        }

    } catch (error) {
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: error.message } });
        //console.log(error);
    }

    dispatch({ type: 'END_LOADING' })
}


/*
    Devuelve a la funcion llamante un objeto:
        Si bien: {success: true, message: 'Mensaje del servidor', result: {objeto con los datos solicitados}}
        Si mal : {success: false}
*/
export const getConfigAlarmaV2 = async (currentUser, deviceId, comando, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //console.log({ currentUser, comando, deviceId });

    //SEND REQUEST WITH POST
    let body = { deviceId, comando };
    try {
        const data = await fetchData({ url: url + `/getConfig`, method: 'POST', body, token: currentUser.token }, dispatch);
        const result = data?.result;
        if (result) {
            //console.log("fetchData Respuesta: ", data);
            dispatch({ type: 'END_LOADING' });
            //return result;
            return data;
        } else {
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: "Algo salió mal. Por favor intenete nuevamente en unos minutos." } });
        }

    } catch (error) {
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: error.message } });
        //console.log(error);
    }

    dispatch({ type: 'END_LOADING' })
    return ({ success: false });
}


export const getDispositivos = async (currentUser, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //console.log({ currentUser });

    //SEND REQUEST WITH POST
    let body = {};
    try {
        const data = await fetchData({ url: url + `/getDisp`, method: 'POST', body, token: currentUser.token }, dispatch);
        const result = data?.result;
        if (result) {
            //console.log({ result });
            dispatch({ type: 'END_LOADING' });
            return result;
        } else {
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: "Algo salió mal. Por favor intenete nuevamente en unos minutos." } });
        }

    } catch (error) {
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: error.message } });
        //console.log(error);
    }

    dispatch({ type: 'END_LOADING' })
}







export const getUsers = async (comando, currentUser, dispatch) => {
    //console.log('-------------->> getUsers');
    //console.log(currentUser);

    if (!currentUser)
        return;

    dispatch({ type: 'START_LOADING' });

    let body = { comando };

    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/getUsers`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        dispatch({ type: 'UPDATE_USERS', payload: result });      //A users se envía el payload como {rows: valor}
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}

export const updateUser = async (datos, currentUser, dispatch) => {
    //dispatch({ type: 'START_LOADING' });  //porque tiene su propio control de loading

    //console.log('-------------->> updateUser');
    //console.log('Datos: ', datos);

    let body = datos;

    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/updateUser`, method: 'PATCH', body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (NuevaMarca): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    //dispatch({ type: 'END_LOADING' })

}

export const getWirelessCode = async (currentUser, devId, comando, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    console.log({ currentUser, devId, comando });
    
    //SEND REQUEST WITH POST
    let body = {devId, comando, data: {}};
    try {
        const data = await fetchData({ url: url + `/sendCommand`, method: 'POST', body, token: currentUser.token }, dispatch);
        const result = data?.result;
        if (result) {
            console.log({ result });
            dispatch({ type: 'END_LOADING' });
            return result;
        } else {
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: "Algo salió mal. Por favor intenete nuevamente en unos minutos." } });
        }

    } catch (error) {
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: error.message } });
        //console.log(error);
    }

    dispatch({ type: 'END_LOADING' })
}